import React from "react";
import { IconColor } from "../VaporIcon/VaporIconType";

export const getColorIcon = (colorVariable: IconColor, theme: any) => {
  switch (colorVariable) {
    case "default":
      return theme.palette.primary["iconDefault"];
      break;
    case "interactive":
      return theme.palette.primary["interactiveDefaultColor"];
      break;
    case "critical":
      return theme.palette.primary["error"];
      break;
    case "disabled":
      return theme.palette.primary["iconDisabled"];
      break;
    case "warning":
      return theme.palette.primary["baseWarningColor"];
      break;
    case "success":
      return theme.palette.primary["successed"];
      break;
    case "info":
      return theme.palette.primary["iconInfoColor"];
      break;
    case "inverse":
      return theme.palette.primary["iconInverse"];
      break;
    case "primary":
      return theme.palette.primary["iconPrimaryColor"];
      break;
    default:
      return theme.palette.primary["iconDefault"];
  }
};
